export function hasCapitalRights() {
  if (typeof window !== 'undefined' && window.merchantos && window.merchantos.session) {
    const lightspeedCapitalRights = ['admin_financial_services'];
    return lightspeedCapitalRights.every((right) => window.merchantos.session.hasRight(right));
  }

  return false;
}
